module.exports = __webpack_public_path__ + "static/Group 4088-388fd6ac4611c358956fbc60750f5e8d.png";